import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DistrictModifyMealSubsidyComponent } from "./district-modify-meal-subsidy/district-modify-meal-subsidy.component";
import { DataService_MealSubsidyType } from "./shared/data.service";

@Component({
	selector: "app-meal-subsidy-type-maintenance",
	templateUrl: "./meal-subsidy-type-maintenance.component.html",
	styleUrls: ["./meal-subsidy-type-maintenance.component.css"],
})
export class MealSubsidyTypeMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private MealSubsidyTypeService: DataService_MealSubsidyType,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadMealSubsidyType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	CanManageSubsidyTypes: boolean = true; //Check preference? (Meal/usercaneditsubsidy is by school and subsidies are by district?)

	processing: any = false;

	ToggleText: any = "Deactivate Subsidy";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMealSubsidyType: any;
	lstMealSubsidyType: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "MealSubsidyTypeCD", header: "Code" },
		{ field: "MealSubsidyTypeDesc", header: "Description" },
		{ field: "MealSubsidyPct", header: "Subsidy Percent" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadMealSubsidyType() {
		this.errorMessage = "";
		this.loading = true;

		var result = this.MealSubsidyTypeService.MealSubsidyTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstMealSubsidyType = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstMealSubsidyType.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadMealSubsidyType();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictModifyMealSubsidyComponent, {
			header: "Add Subsidy",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMealSubsidyType();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedMealSubsidyType == undefined) {
			this.errorMessage = "Select a Subsidy Type to Edit";
			return;
		}

		var ref = this.dialogService.open(DistrictModifyMealSubsidyComponent, {
			header: "Edit Subsidy",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				EditMode: true,
				MealSubsidyTypeID: this.SelectedMealSubsidyType.MealSubsidyTypeID,
				MealSubsidyTypeCD: this.SelectedMealSubsidyType.MealSubsidyTypeCD,
				MealSubsidyTypeDesc: this.SelectedMealSubsidyType.MealSubsidyTypeDesc,
				MealSubsidyPct: this.SelectedMealSubsidyType.MealSubsidyPct,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMealSubsidyType();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMealSubsidyType == undefined) {
			this.errorMessage = "Select a meal subsidy type to delete";
			return;
		}

		//Call SP
		this.processing = true;

		var result = this.MealSubsidyTypeService.MealSubsidyTypeDelete(this.SelectedMealSubsidyType.MealSubsidyTypeID);
		result.subscribe(
			(response) => {
				this.processing = false;

				var lstError: any = response;

				if (lstError.length == 0) {
					this.loadMealSubsidyType();
				} else {
					var MSG = lstError[0];

					//Error
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMealSubsidyType == undefined) {
			this.errorMessage = "Select a meal subsidy type to activate or deactivate";
			return;
		}

		this.processing = true;

		var changeTo = this.SelectedMealSubsidyType.Active == true ? 0 : 1;

		//Call SP
		var result = this.MealSubsidyTypeService.MealSubsidyTypeToggle(this.SelectedMealSubsidyType.MealSubsidyTypeID, changeTo);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					this.onRowUnselect(null);
					this.loadMealSubsidyType();
				} else {
					var MSG = "Could not ";
					if (changeTo == 1) {
						MSG += "activate";
					} else {
						MSG += "deactivate";
					}
					MSG += " the subsidy type";

					//Error
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedMealSubsidyType = val.data;

		if (this.SelectedMealSubsidyType.Active == false) {
			this.ToggleText = "Activate Subsidy";
		} else {
			this.ToggleText = "Deactivate Subsidy";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedMealSubsidyType = null;

		this.ToggleText = "Deactivate Subsidy";
	}
	onRowDblClick(MealSubsidyType) {
		this.errorMessage = "";

		this.SelectedMealSubsidyType = MealSubsidyType;

		if (this.SelectedMealSubsidyType.Active == false) {
			this.ToggleText = "Activate Subsidy";
		} else {
			this.ToggleText = "Deactivate Subsidy";
		}

		if (this.IsLoading() == false) {
			this.onEdit();
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		// Can't Edit
		if (this.CanManageSubsidyTypes == false) {
			return true;
		} else {
			return this.loading == true || this.processing == true;
		}
	}

	////////////////////////////////////////////
}
